import { useEffect } from 'react';

import { LoadingMessage } from '@/components/common/Spinner';
import { currentMonth } from '@/utils/months';
import { useBudgetStore } from '@/store/budget';
import { BudgetSummaryCard } from './BudgetSummaryCard';
import { BudgetTable } from './BudgetTable';
import { MonthCountSelector } from './MonthCountSelector';
import { MonthPicker } from './MonthPicker';

/** Port of `components/budget/index.tsx` → `Budget` → the envelope view. */
export function BudgetPage() {
  const months = useBudgetStore(state => state.months);
  const loading = useBudgetStore(state => state.loading);
  const error = useBudgetStore(state => state.error);

  useEffect(() => {
    void useBudgetStore.getState().load();
  }, []);

  if (error) {
    return (
      <div className="flex flex-1 items-center justify-center text-sm text-error-text">
        {error}
      </div>
    );
  }

  if (months.length === 0) {
    return <LoadingMessage message="正在加载预算…" />;
  }

  const thisMonth = currentMonth();

  return (
    <div className="flex min-h-0 flex-1 flex-col" data-testid="budget-page">
      <div className="flex shrink-0 items-center justify-between gap-2 px-2 pt-1">
        <MonthCountSelector />
        <MonthPicker />
        <span className="w-[70px] shrink-0" />
      </div>

      <div className="scrollable flex shrink-0 items-start justify-center gap-5 overflow-x-auto px-5 py-3">
        {months.map(month => (
          <BudgetSummaryCard
            key={month.month}
            data={month}
            isCurrent={month.month === thisMonth}
          />
        ))}
      </div>

      {loading && (
        <div className="px-5 pb-1 text-xs text-page-text-light">正在刷新…</div>
      )}

      <BudgetTable months={months} />
    </div>
  );
}
